import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import { MAILTO_COMMERCIAL, TEL_SEGRETERIA } from "../../../../constants/contacts";
import Button from "../../../../components/ui/button/button";
import "./contacts-ready.scss";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

const ContactReady = () => {
  const device = useBreakpoint();
  const isMoblie = device === "mobile";

  return (
    <section className="contacts-ready">
      <Fade direction="up" duration={800} triggerOnce>
        <IntroSectionBadge
          title={"Pronto per il Tuo Progetto?"}
          text={
            "Contattaci oggi stesso per una consulenza gratuita e scopri come possiamo realizzare insieme il tuo progetto."
          }
          bgColor={"dark"}
        />
      </Fade>
      <Fade
        direction="up"
        duration={900}
        delay={200}
        cascade
        damping={0.2}
        triggerOnce
        style={{ width: "100%" }}
      >
        <div className="contacts-ready__buttons">
          <Button
            text={"Contattaci"}
            type="primary"
            iconName={"phone"}
            fullWidth={isMoblie}
            fitContent={!isMoblie}
            href={TEL_SEGRETERIA}
          />

          <Button
            text={"Invia Email"}
            type="secondary"
            iconName={"envelope"}
            fullWidth={isMoblie}
            fitContent={!isMoblie}
            href={MAILTO_COMMERCIAL}
          />
        </div>
      </Fade>
      <div className="contacts-ready__divider" />
    </section>
  );
};

export default ContactReady;
